import * as React from 'react';
import styled from 'styled-components';
import { Flex } from '../compositeComponents/FlexHelpers';
import { Divider } from '../Divider';

type Layout2Props = {
    header:React.ReactNode,
    content:React.ReactNode
}
export function Layout2(props:Layout2Props):JSX.Element
{
    return (
        <Wrapper>
            <Flex flexDirection="column" gap={32}>
                <div>
                    {props.header}
                    <Divider />
                </div>
                {props.content}
            </Flex>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width:100%;
    margin: 32px auto 0px auto;
    max-width: 1020px;
    padding:0px 10px;
`;
